import React from 'react';
import { NavLink } from 'react-router-dom';

const DashboardCrumb = () => <NavLink to="/dashboard">Dashboard</NavLink>;

export default DashboardCrumb;
